import axios from 'axios/index';
import { GET_AGENTS } from '../../utils/constants';

const getAgents = (hash) => { // queries === object

    return axios.get(GET_AGENTS, {
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/pdf",
            "Accept-language": "bg",
            "Authorization": hash,
        }
    }).then(resp => {
        return resp.data;
    }).catch(err => {
        console.error(err)
    })

}

export default getAgents